
import ChangePassword from "../../component/admin/auth/ChangePassword";
import Dashboard from "../../component/admin/Dashboard";
import AddPostSite from "../../component/admin/post_site/AddPostSite";
import EditPostSite from "../../component/admin/post_site/EditPostSite";
import ListPostSite from "../../component/admin/post_site/ListPostSite";
import ViewPostSite from "../../component/admin/post_site/ViewPostSite";
import Profile from "../../component/admin/Profile";
import AddUser from "../../component/admin/user/AddUser";
import EditUser from "../../component/admin/user/EditUser";
import ListUser from "../../component/admin/user/ListUser";
import ViewUser from "../../component/admin/user/ViewUser";

import AddSubAdmin from "../../component/admin/subadmin/AddSubAdmin";
import EditSubAdmin from "../../component/admin/subadmin/EditSubAdmin";
import ListSubAdmin from "../../component/admin/subadmin/ListSubAdmin";
import ViewSubAdmin from "../../component/admin/subadmin/ViewSubAdmin";
import AddPage from "../../component/admin/page/AddPage";
import ListPage from "../../component/admin/page/ListPage";
import ViewPage from "../../component/admin/page/ViewPage";
import EditPage from "../../component/admin/page/EditPage";
import ListContact from "../../component/admin/contact/ContactList";
import ViewContact from "../../component/admin/contact/ViewContact";
const Routes = [
  
    { path: '/admin', exact: true, name:'Admin' },
    { path: '/admin/dashboard', exact: true, name:'Dashboard', component: Dashboard },
    { path: '/admin/profile', exact: true, name:'Profile', component: Profile },
    { path: '/admin/sub-admin/add', exact: true, name:'AddSubAdmin', component: AddSubAdmin},
    { path: '/admin/sub-admin/index', exact: true, name:'ListSubAdmin', component: ListSubAdmin },
    { path: '/admin/sub-admin/view/:id', exact: true, name:'ViewSubAdmin', component: ViewSubAdmin },
    { path: '/admin/sub-admin/edit/:id', exact: true, name:'EdiSubAdmin', component: EditSubAdmin },
    
    { path: '/admin/page/add', exact: true, name:'AddPage', component: AddPage},
    { path: '/admin/page/index', exact: true, name:'ListPage', component: ListPage },
    { path: '/admin/page/view/:id', exact: true, name:'ViewPage', component: ViewPage },
    { path: '/admin/page/edit/:id', exact: true, name:'EditPage', component: EditPage },
    
    { path: '/admin/user/add', exact: true, name:'AddUser', component: AddUser },
    { path: '/admin/user/index', exact: true, name:'ListUser', component: ListUser },
    { path: '/admin/user/view/:id', exact: true, name:'ViewUser', component: ViewUser },
    { path: '/admin/user/edit/:id', exact: true, name:'EditUser', component: EditUser },
    { path: '/admin/post-site/index', exact: true, name:'ListPostSite', component: ListPostSite },
    { path: '/admin/post-site/add', exact: true, name:'AddPostSite', component: AddPostSite },
    { path: '/admin/post-site/edit/:id', exact: true, name:'EditPostSite', component: EditPostSite },
    { path: '/admin/post-site/view/:id', exact: true, name:'ViewPostSite', component: ViewPostSite },
    { path: '/admin/change-password/:id', exact: true, name:'ChangePassword', component: ChangePassword },
    { path: '/admin/contact/list', exact: true, name:'ContactList', component: ListContact },
    { path: '/admin/contact/detail/:id', exact: true, name:'ViewContact', component: ViewContact },

];

export default Routes;